import gql from 'graphql-tag'

export const getStatementById = gql`
  query($statementId: Int!) {
    getStatementById(
      statementId: $statementId
    ) {
      id
      yearAndMonth
      statementCarrier
      createdAt
      details {
        id
        valuesStr
        policy {
          id
          policyName
        }
      }
      carrier {
        id
        name
      }
      file {
        id
        name
        size
        type
        masterId
      }
      carrier {
        id
        name
      }
      createdBy {
        id
        username
      }
    }
  }
`

export const getStatements = gql`
  query($paging: PagingQuery, $order: StatementsOrder, $statementsFilter: StatementsFilter!) {
    getStatements(
      statementsFilter: $statementsFilter,
      order: $order,
      paging: $paging
    ) {
      statements {
        id
        yearAndMonth
        statementCarrier
        createdAt
        updatedAt
        carrier {
          id
          name
        }
        file {
          id
          name
          size
          type
          masterId
        }
        createdBy {
          id
          username
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const deleteStatementById = gql`
  mutation($statementId: Int!) {
    deleteStatementById(
      statementId: $statementId
    )
  }
`

export const bindPolicyAndStatement = gql`
  mutation($statementDetailId: Int!, $policyId: Int!) {
    bindPolicyAndStatement(
      statementDetailId: $statementDetailId,
      policyId: $policyId
    )
  }
`

export const getPoliciesByNameAndNumber = gql`
  query($policyName: String, $policyNumber: String) {
    getPoliciesByNameAndNumber(
      policyName: $policyName,
      policyNumber: $policyNumber
    ) {
      id
      policyName
      status
      effectiveDate
      expirationDate
      policyNumber
      createdAt
      updatedAt
      carrier {
        id
        name
      }
    }
  }
`

export const pdfReader = gql`
  mutation($carrierName: StatementCarrier!, $month: String, $file: Upload!) {
    pdfReader(
      carrierName: $carrierName,
      month: $month,
      file: $file
    ) {
      id
      yearAndMonth
      statementCarrier
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
    }
  }
`
